'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

var _class, _temp; // import LinearProgress from 'material-ui/Progress/LinearProgress';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _graphqlTag = require('graphql-tag');

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

var _Button = require('material-ui/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Typography = require('material-ui/Typography');

var _Typography2 = _interopRequireDefault(_Typography);

var _Dialog = require('material-ui/Dialog');

var _ = require('../');

var _2 = _interopRequireDefault(_);

var _ethereumjsUtil = require('ethereumjs-util');

var ethUtil = _interopRequireWildcard(_ethereumjsUtil);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
}

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var MetamaskForm = (_temp = _class = function (_AuthForm) {
  _inherits(MetamaskForm, _AuthForm);

  function MetamaskForm() {
    _classCallCheck(this, MetamaskForm);

    return _possibleConstructorReturn(this, (MetamaskForm.__proto__ || Object.getPrototypeOf(MetamaskForm)).apply(this, arguments));
  }

  _createClass(MetamaskForm, [{
    key: 'onChange',
    value: function onChange(event) {
      var _event$target = event.target,
          name = _event$target.name,
          value = _event$target.value;
      var data = this.state.data;
      this.setState({
        data: _extends({}, data, _defineProperty({}, name, value))
      });
    }
  }, {
    key: 'connect',
    value: function connect() {
      var _global = global,
          ethereum = _global.ethereum;

      if (typeof ethereum !== 'undefined') {
        ethereum.enable().catch(console.error);
      }
    }
  }, {
    key: 'renderFields',
    value: function renderFields() {
      var Grid = this.context.Grid;
      var data = this.state.data;
      var output = void 0;
      var _global2 = global,
          ethereum = _global2.ethereum;
      /**
       * Check metamask plugin
       */

      if (!ethereum) {
        output = _react2.default.createElement('div', null, _react2.default.createElement(_Typography2.default, {
          color: 'error',
          variant: 'subheading'
        }, "\u041F\u043B\u0430\u0433\u0438\u043D Metamask \u043D\u0435 \u043E\u0431\u043D\u0430\u0440\u0443\u0436\u0435\u043D."), _react2.default.createElement(_Typography2.default, null, "\u0421\u043C\u043E\u0442\u0440\u0438\u0442\u0435 \u0438\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u044E \u043F\u043E \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0435 \u043D\u0430 ", _react2.default.createElement('a', {
          href: 'https://metamask.io/',
          target: '_blank'
        }, "\u043E\u0444\u0438\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u043C \u0441\u0430\u0439\u0442\u0435"), '.'));
      } else {
        output = _react2.default.createElement('div', null, _react2.default.createElement(_Typography2.default, null, "\u0411\u0443\u0434\u0435\u0442 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0430 \u043F\u043E\u043F\u044B\u0442\u043A\u0430 \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u0438 \u0447\u0435\u0440\u0435\u0437 \u0441\u0435\u0442\u044C Ethereum."), _react2.default.createElement(_Typography2.default, null, "\u0415\u0441\u043B\u0438 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0435 \u0435\u0449\u0435 \u043D\u0435\u0442, \u0431\u0443\u0434\u0435\u0442 \u0441\u043E\u0437\u0434\u0430\u043D \u043D\u043E\u0432\u044B\u0439 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C."), _react2.default.createElement(_Typography2.default, null, "\u0415\u0441\u043B\u0438 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0435 \u0443\u0436\u0435 \u0435\u0441\u0442\u044C, \u043E\u043D \u0431\u0443\u0434\u0435\u0442 \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u043E\u0432\u0430\u043D."));
      }

      return output;
    }
  }, {
    key: 'signup',
    value: function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee2() {
        var _this2 = this;

        var _global3, ethereum, web3;

        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _global3 = global, ethereum = _global3.ethereum, web3 = _global3.web3;

                if (ethereum) {
                  _context2.next = 4;
                  break;
                }

                this.addError("Плагин Metamask не обнаружен");
                return _context2.abrupt('return');

              case 4:
                _context2.next = 6;
                return ethereum.enable().then(function (async) {
                  var from = ethereum.selectedAddress;

                  if (!from) {
                    return _this2.connect();
                  }

                  var message = "\n    \u0411\u0443\u0434\u0435\u0442 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0430 \u043F\u043E\u043F\u044B\u0442\u043A\u0430 \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u0438 \u0447\u0435\u0440\u0435\u0437 \u0441\u0435\u0442\u044C Ethereum \u0441 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430 " + from + ".\n\n    \u0415\u0441\u043B\u0438 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0435 \u0435\u0449\u0435 \u043D\u0435\u0442, \u0431\u0443\u0434\u0435\u0442 \u0441\u043E\u0437\u0434\u0430\u043D \u043D\u043E\u0432\u044B\u0439 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C.\n\n    \u0415\u0441\u043B\u0438 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0435 \u0443\u0436\u0435 \u0435\u0441\u0442\u044C, \u043E\u043D \u0431\u0443\u0434\u0435\u0442 \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u043E\u0432\u0430\u043D.\n    ";
                  var msg = ethUtil.bufferToHex(new Buffer(message, 'utf8'));
                  var params = [msg, from];
                  var method = 'personal_sign';
                  web3.currentProvider.sendAsync({
                    method: method,
                    params: params,
                    from: from
                  }, function () {
                    var _ref2 = _asyncToGenerator(
                    /*#__PURE__*/
                    _regenerator2.default.mark(function _callee(err, result) {
                      var error, signature, queryFragments, _ref3, _ref3$UserNoNestingFr, UserNoNestingFragment, _ref4, _ref4$signup, signup, signupInRequest, data, auth;

                      return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              if (!err) {
                                _context.next = 3;
                                break;
                              }

                              _this2.addError(err);

                              return _context.abrupt('return');

                            case 3:
                              error = result.error, signature = result.result;

                              if (!error) {
                                _context.next = 7;
                                break;
                              }

                              console.error(result.error); // this.addError(error && error.message || "Неизвестная ошибка");

                              return _context.abrupt('return');

                            case 7:
                              // else
                              queryFragments = _this2.context.queryFragments;
                              _ref3 = queryFragments || {}, _ref3$UserNoNestingFr = _ref3.UserNoNestingFragment, UserNoNestingFragment = _ref3$UserNoNestingFr === undefined ? 'fragment UserNoNesting on User {\n              id\n              createdAt\n              updatedAt\n              username\n              email\n              phone\n              showEmail\n              showPhone\n              fullname\n              image\n              address\n              active\n              activated\n              deleted\n              hidden\n              marketplaceToken\n              sudo\n              hasEmail\n              hasPhone\n            }' : _ref3$UserNoNestingFr;
                              _ref4 = _this2.context.query || {}, _ref4$signup = _ref4.signup, signup = _ref4$signup === undefined ? '\n            mutation ethSigninOrSignup(\n              $data:EthRecoverPersonalSignatureDataInput!\n            ){\n              response: ethSigninOrSignup(\n                data:$data\n              ){\n                success\n                message\n                errors{\n                  key\n                  message\n                }\n                token\n                data{\n                  ...UserNoNesting\n                }\n              }\n            }\n            \n            ' + UserNoNestingFragment + '\n          ' : _ref4$signup;
                              signupInRequest = _this2.state.signupInRequest;

                              if (!signupInRequest) {
                                _context.next = 13;
                                break;
                              }

                              return _context.abrupt('return');

                            case 13:
                              _this2.setState({
                                signupInRequest: true
                              });

                              data = {
                                message: message,
                                signature: signature,
                                from: from
                              };
                              _context.next = 17;
                              return _this2.mutate({
                                mutation: (0, _graphqlTag2.default)(signup),
                                variables: {
                                  data: data
                                }
                              }).then(function (r) {
                                _this2.onAuth(r);

                                return r;
                              }).catch(function (error) {
                                console.error(error);
                                return error;
                              });

                            case 17:
                              auth = _context.sent;

                              _this2.setState({
                                signupInRequest: false
                              });

                              return _context.abrupt('return', auth);

                            case 20:
                            case 'end':
                              return _context.stop();
                          }
                        }
                      }, _callee, _this2);
                    }));

                    return function (_x, _x2) {
                      return _ref2.apply(this, arguments);
                    };
                  }());
                }).catch(function (error) {
                  _this2.addError(error);

                  console.error(error);
                });

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function signup() {
        return _ref.apply(this, arguments);
      }

      return signup;
    }()
  }, {
    key: 'cleanForm',
    value: function cleanForm() {
      this.setState({
        data: null
      });
      this.switchForm("signin");
      return _get(MetamaskForm.prototype.__proto__ || Object.getPrototypeOf(MetamaskForm.prototype), 'cleanForm', this).call(this);
    }
  }, {
    key: 'renderForm',
    value: function renderForm() {
      var _this3 = this;

      _objectDestructuringEmpty(this.context);

      var data = this.state.data;
      var actions = [];
      var values = Object.values(_extends({}, data)).filter(function (n) {
        return n;
      });
      actions.push(_react2.default.createElement(_Button2.default, {
        key: 'submit',
        color: 'primary',
        type: 'submit',
        size: 'small'
      }, this.lexicon("Signin")));
      actions.push(_react2.default.createElement(_Button2.default, {
        key: 'cancel' // color="primary"
        ,
        onClick: function onClick(event) {
          _this3.closeForm();
        },
        size: 'small'
      }, this.lexicon("Cancel")));
      return _react2.default.createElement('form', {
        style: {
          width: "100%"
        },
        onSubmit: function onSubmit(event) {
          event.preventDefault();

          _this3.signup();
        }
      }, _react2.default.createElement(_Dialog.DialogTitle, null, this.lexicon("Metamask")), _react2.default.createElement(_Dialog.DialogContent, null, this.renderFields()), _react2.default.createElement(_Dialog.DialogActions, null, actions));
    } // render() {
    //   return (
    //     <div>
    //     </div>
    //   );
    // }

  }]);

  return MetamaskForm;
}(_2.default), _class.propTypes = _extends({}, _2.default.propTypes), _temp);
exports.default = MetamaskForm;
module.exports = exports['default'];